import React from "react"
import type { SkinnyBanner } from "types"
import { createMarkup } from "utils/createMarkup"
import { useSkinnyBannerItem } from "../Banner/useSkinnyBannerItem"
import { smallprintText, smallprintContainer } from "./Smallprint.css"
import { useFeatureFlag } from "../../../hooks"
import { ExperimentFlags } from "@shared/utils.experimentation"

type Props = {
  skinnyBannerData: SkinnyBanner[]
}

export const Smallprint: React.FC<Props> = ({ skinnyBannerData }) => {
  const smallPrintData = useSkinnyBannerItem(skinnyBannerData)
  const [loading, freeShippingFeatureFlag] = useFeatureFlag(
    ExperimentFlags.USE_FREE_SHIPPING_THRESHOLD,
    "0"
  )

  if (!smallPrintData?.smallPrint) {
    return null
  }

  if (loading || freeShippingFeatureFlag !== "0") {
    return null
  }

  const { title, smallPrint } = smallPrintData

  return (
    <div key={title} className={smallprintContainer} data-testid="Smallprint">
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={createMarkup(smallPrint)}
        className={smallprintText}
      />
    </div>
  )
}
